import { Notification, Status } from "./Notification/Notification";

const INIDICATIVE_CALCULATION_NOTE_P1 = `Note: The amounts shown above are indicative based on the details you have provided for your Bounce Back Loan. The amounts included in the documentation we send you will differ as they will be calculated using our records.`;

const INIDICATIVE_CALCULATION_NOTE_P2 = `Please carefully review the legal documentation and calculations when you receive them before agreeing to proceed.`;
export const IndicativeCalculationBanner = () => (
  <div className="section-margin">
    <Notification title={""} status={Status.INFO}>
      <div>{INIDICATIVE_CALCULATION_NOTE_P1}</div>
      <div className="newline">{INIDICATIVE_CALCULATION_NOTE_P2}</div>
    </Notification>
  </div>
);
